import { render } from "./SuplierBalance.vue?vue&type=template&id=4980c6c9&scoped=true"
import script from "./SuplierBalance.vue?vue&type=script&lang=js"
export * from "./SuplierBalance.vue?vue&type=script&lang=js"

import "./SuplierBalance.vue?vue&type=style&index=0&id=4980c6c9&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4980c6c9"]])

export default __exports__